import { IFiscalClient } from "@prostocheck/shared";

/**
 * ДПС processes **one request at a time per taxpayer**. A second one that
 * overlaps is refused with «Наразі триває обробка іншого запиту» — measured
 * against the live server; the ДПС document does not mention it.
 *
 * So every command goes through a per-client queue. Callers keep their natural
 * shape — `Promise.all` over registers, a fan-out over shifts — and the rule is
 * enforced in the one place that talks to the server.
 */
const queues = new WeakMap<IFiscalClient, Promise<unknown>>();

export const enqueue = <TResult>(
  client: IFiscalClient,
  run: () => Promise<TResult>,
): Promise<TResult> => {
  // Failures must not poison the chain: the next request still has to run.
  const next = (queues.get(client) ?? Promise.resolve()).then(run, run);

  queues.set(
    client,
    next.catch(() => undefined),
  );

  return next;
};
